// extracted by mini-css-extract-plugin
var _1 = "Result_count__b787e";
var _2 = "Result_progress__58ca4";
var _3 = "Result_root__25a8f";
var _4 = "Result_tryAgain__4d8b7";
export { _1 as "count", _2 as "progress", _3 as "root", _4 as "tryAgain" }
